import { updates } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">更新快讯</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            每日最新漫画更新动态，不错过任何一部热追连载
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-secondary-200 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-4 md:space-y-0">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-0 md:items-center ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className={`bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200 ${
                    i % 2 === 0 ? 'md:ml-auto md:mr-0' : 'md:mr-auto md:ml-0'
                  } md:max-w-[440px]`}>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100/70 text-accent-700">
                        {item.tag}
                      </span>
                    </div>
                    <a
                      href={item.link}
                      onClick={(e) => { e.preventDefault(); document.querySelector(item.link)?.scrollIntoView({ behavior: 'smooth' }); }}
                      className="text-sm md:text-base text-foreground-800 hover:text-primary-500 transition-colors leading-relaxed font-medium cursor-pointer"
                    >
                      {item.title}
                    </a>
                  </div>
                </div>

                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 z-10"></div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}